export const messages = {
  en: {
    storeAds: {
      title: 'Store Ads Management',
      queryTitle: 'Query Conditions',
      listTitle: 'Store Ads List',
      adName: 'Ad Name',
      adType: 'Ad Type',
      adImage: 'Ad Image',
      seq: 'Sequence',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      operation: 'Operation',
      publish: 'Publish',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      query: 'Query',
      reset: 'Reset',
      requiredAdName: 'Please input ad name',
      requiredAdType: 'Please select ad type',
      requiredSeq: 'Please input sequence',
      requiredStartTime: 'Please select start time',
      requiredEndTime: 'Please select end time',
      requiredImage: 'Please upload ad image',
      publishSuccess: 'Publish Success',
      editSuccess: 'Edit Success',
      deleteSuccess: 'Delete Success',
      linkAddress: 'Link Address',
      optional: 'Optional'
    }
  },
  zh: {
    storeAds: {
      title: '店铺广告管理',
      queryTitle: '查询条件',
      listTitle: '店铺广告列表',
      adName: '广告名称',
      adType: '广告类型',
      adImage: '广告图片',
      seq: '顺序',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '发布时间',
      operation: '操作',
      publish: '发布',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      query: '查询',
      reset: '重置',
      requiredAdName: '请输入广告名称',
      requiredAdType: '请选择广告类型',
      requiredSeq: '请输入顺序',
      requiredStartTime: '请选择开始时间',
      requiredEndTime: '请选择结束时间',
      requiredImage: '请上传广告图片',
      publishSuccess: '发布成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      linkAddress: '链接地址',
      optional: '选填'
    }
  }
}